// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"749":"c29a340a","788":"aade4aec","891":"1d2220a7","968":"22ff92d3"}[chunkId] + ".chunk.js";
};